import React from "react";
import Alert from "./page/alert";
import Cards from "./page/cards";
import Gallery from "./page/gallery";
import Image from "./page/image";
import ImageText from "./page/image-text";
import Text from "./page/text";
import TextImage from "./page/text-image";
import TextText from "./page/text-text";
import Widget from "./widget";

const Content = ({content}) => {
    return content.map((contentItem) => {
        switch (contentItem.strapi_component) {
            case "page.alert":
                return (<Alert key={contentItem.id} alert={contentItem} />)
            case "page.cards":
                return (<Cards key={contentItem.id} cards={contentItem} />)
            case "page.gallery":
                return (<Gallery  key={contentItem.id} gallery={contentItem} />)
            case "page.image":
                return (<Image  key={contentItem.id} image={contentItem} />)
            case "page.image-text":
                return (<ImageText  key={contentItem.id} component={contentItem} />)
            case "page.text":
                return (<Text  key={contentItem.id} component={contentItem} />)
            case "page.text-image":
                return (<TextImage  key={contentItem.id} component={contentItem} />)
            case "page.text-text":
                return (<TextText  key={contentItem.id} component={contentItem} />)
            case "page.widget":
                return (<Widget key={contentItem.id} settings={contentItem.widget.Settings} name={contentItem.widget.Name} />)
            default:
                return (<h1 key={contentItem.id} >{contentItem.strapi_component}</h1>)
        }
    })
}

export default Content